import React, { useEffect } from 'react';
import { SuccessModal } from '@it25syv/25syv-ui';
import { hideModal as HideModal } from '../../actions/UiActions';
import { connect } from 'react-redux';
import { disableBodyScroll } from '../../utils/UiHelper';

const SuccessProfileUpdate = ({ hideModal }) => {
    useEffect(() => {
        return () => {
            disableBodyScroll();
        };
    }, []);
    return (
        <div>
            <SuccessModal
                closeModal={() => hideModal('SUCCESS_PROFILE_UPDATE')}
                title={`Oplysninger opdateret`}
                text={`Dine kontooplysninger er nu opdateret og gemt.`}
            />
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        //showModal: (modalId, data) => dispatch(ShowModal(modalId, data)),
        hideModal: (modalId) => dispatch(HideModal(modalId)),
    };
};

export default connect(
    null,
    mapDispatchToProps
)(SuccessProfileUpdate);
